var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgInformation = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.253,
    height: 18,
    viewBox: "0 0 17.253 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.627)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#95A1B2",
    d: "M27.88,8.626a8.629,8.629,0,0,1-12.327,7.795L12.5,18l.527-3.4A8.627,8.627,0,1,1,27.88,8.626Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.18 2.583)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#ffffff",
    cx: 1.518,
    cy: 1.518,
    r: 1.518,
    transform: "translate(0.556)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M201.163,203.07v1.175h-4.147V203.07h.756V198.1h-.756v-1.174h3.392v6.148Z",
    transform: "translate(-197.016 -192.582)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInformation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/information.7adf854e.svg";
export { ForwardRef as ReactComponent };